// @flow

import { all, put, takeEvery } from "redux-saga/effects";
import http from "@http";
import { call } from "redux-saga/effects";
import { downloadCsvFile } from "@sagas/utils";
import config from "@config";

import actionCreator from "@modules/reporting/actionCreator";
import * as actions from "@modules/reporting/constants/actions";

export function* onGetDataForecasts({ payload }: Object): Generator<void, void, *> {
  try {
    if (!payload || !payload.period || !payload.model) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.post,
      `${config.dataForecastsEndpointBaseUrl}data-forecast/${payload.clientId}`,
      {
        period: payload.period,
        model_type: payload.model,
      },
    );

    yield put(actionCreator.GetDataForecastsSuccess(response.data));
  } catch (e) {
    yield put(actionCreator.GetDataForecastsError(e.response));
  }
}

export function* onExportTop10Department({ payload }: Object): Generator<void, void, *> {
  try {
    if (!payload || !payload.period || !payload.model || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.post,
      `${config.dataForecastsEndpointBaseUrl}data-forecast/${payload.clientId}/department/export`,
      {
        period: payload.period,
        model_type: payload.model,
      },
    );
    downloadCsvFile(response.data, `Top 10 Department.csv`);
  } catch (e) {
    yield put(actionCreator.GetDataForecastsError(e.response));
  }
}

export function* TasksSaga(): Generator<*, void, void> {
  yield all([takeEvery(actions.GetDataForecasts, onGetDataForecasts)]);
  yield all([takeEvery(actions.ExportTop10Department, onExportTop10Department)]);
}

export default TasksSaga;
